import React from "react";
import { Modal } from "react-bootstrap";
import classNames from "classnames";

export function SlideOut({ placement, backdrop = "static", className, ...restProps }) {
  const modalClassName = classNames("slide-out-wrapper", className, {
    [`slide-out-placement-${placement}`]: placement
  });

  return (
    <Modal
      backdrop={backdrop}
      className={modalClassName}
      {...restProps}
    />
  );
}

export const SlideOutHeader = (props) => {
  return (
    <Modal.Header
      {...props}
      className={classNames("slide-out-header", props.className)}
    />
  );
};

export const SlideOutBody = (props) => {
  return (
    <Modal.Body
      {...props}
      className={classNames("slide-out-body", props.className)}
    />
  );
};

export const SlideOutFooter = (props) => {
  return (
    <Modal.Footer
      {...props}
      className={classNames("slide-out-body", props.className)}
    />
  );
};

export const SlideOutTitle = (props) => {
  return (
    <Modal.Title
      {...props}
      className={classNames("slide-out-title", props.className)}
    />
  );
};

SlideOut.Header = SlideOutHeader;
SlideOut.Body = SlideOutBody;
SlideOut.Footer = SlideOutFooter;
SlideOut.Title = SlideOutTitle;
export default SlideOut;
